import type ContractVersion from 'modules/contracts/store/models/ContractVersion'
import type ContractVersionRequest from 'modules/contracts/store/models/ContractVersionRequest'
import { Employees } from 'modules/employees/store/collections/employees'

export const contractVersionEmployee = (
  contractVersion: ContractVersion | ContractVersionRequest,
  employees: Employees
) => {
  return employees.get(contractVersion.attributes.employee_id)
}
